import * as React from "react";

const SvgStory = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="currentColor"
  >
    <path
      d="M5.66667 13.3333C5.11438 13.3333 4.66667 12.8856 4.66667 12.3333V3.66666C4.66667 3.11437 5.11438 2.66666 5.66667 2.66666H10.3333C10.8856 2.66666 11.3333 3.11437 11.3333 3.66666V12.3333C11.3333 12.8856 10.8856 13.3333 10.3333 13.3333H5.66667ZM2.66667 12C2.29848 12 2 11.7015 2 11.3333V4.66666C2 4.29847 2.29848 3.99999 2.66667 3.99999C3.03486 3.99999 3.33333 4.29847 3.33333 4.66666V11.3333C3.33333 11.7015 3.03486 12 2.66667 12ZM13.3333 12C12.9651 12 12.6667 11.7015 12.6667 11.3333V4.66666C12.6667 4.29847 12.9651 3.99999 13.3333 3.99999C13.7015 3.99999 14 4.29847 14 4.66666V11.3333C14 11.7015 13.7015 12 13.3333 12ZM6 12H10V3.99999H6V12Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgStory;
